import React, {useContext} from 'react'
import {NavLink} from 'react-router-dom'

const CategoryFilter = () => {

    
    const categorias = [  
        {
            id: 1,
            category: "Calefacción",
            category_url: "calefaccion",
        },
        {
            id: 2,
            category: "Aerotérmia",
            category_url: "aerotermia",
        },
        {
            id: 3,
            category: "Energía Solar Térmica",
            category_url: "energia_solar_termica",
        },
        {
            id: 4,
            category: "Energía Solar",
            category_url: "energia_solar",
        }
      ]
      

    return (
        <>
            { categorias.map((categoria) =>{
                return (
                    <li key={categoria.id}>
                        <NavLink to={"/categorias/"+ categoria.category_url}>{categoria.category}</NavLink>
                    </li>
                );
                })
            }
        </>
    )
}

export default CategoryFilter
